// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var contentRouter = {
  path: '/mealOrder',
  component: Layout,
  redirect: '/mealOrder/mealShop',
  name: 'mealOrder',
  meta: {
    title: '小程序装修',
    icon: 'clipboard'
  },
  children: [{
    path: 'mealBrand',
    name: 'mealBrand',
    component: function component() {
      return import('@/views/mealOrder/mealView/mealBrand');
    },
    meta: {
      title: '品牌管理',
      icon: ''
    }
  }, {
    path: 'mealShop',
    name: 'mealShop',
    component: function component() {
      return import('@/views/mealOrder/mealView/mealShop');
    },
    meta: {
      title: '门店管理',
      icon: ''
    }
  }, {
    path: 'mealConfig',
    name: 'mealConfig',
    component: function component() {
      return import('@/views/mealOrder/mealView/mealConfig');
    },
    meta: {
      title: '线下点餐配置',
      icon: ''
    }
  }]
};
export default contentRouter;